export default __webpack_public_path__ + "static/media/shrutiB.f3666807.wav";